import TsdiCounty from './TsdiCounty';

export default class ProspectDetails {
    id: number;
    clientNumber?: number;
    clientName?: string;
    county?: string;
    dayRate?: number;
    number: number;
    name: string;
    clientContact: number;
    clientContactName: string;
    mileageRate: number;
    manager: string;
    managerName: string;
    clientReferenceNo: string;
    managingOffice: string;
    bizDevMgr: number;
    bizDevMgrName: number;
    crewChief: number;
    crewChiefName: string;
    bdBonus: boolean;
    turnkey: boolean;
    type: string;
    afeNumber: string;
    district: string;
    creationDate: Date;
    completionDate: Date;
    project: string;
    splitOmp: string;
    projectCoord: number;
    projectCoordName: string;
    wellName: string;
    easternTownship: string;
    beginningServices: number;
    hideProspectOnInvoice: number;
    clientLandmanUse: number;
    clientApContactNo: number;
    clientApContactName: string;
    attachedDocuments: number;
    backupOfficeRate?: number;
    billMode?: number;
    billBy?: string;
    bopRate?: number;
    state?: string;
    modByNo?: number;
    modByName?: string;
    counties?: Array<TsdiCounty>;
}



// WEBPACK FOOTER //
// ./src/models/projectSettings/TsdiProspect.ts